import React from 'react';

const Documentation = () => {
  return (
    <div>
      <h1>Documentation</h1>
    </div>
  );
};

export default Documentation; 